import { createUrl } from 'app/utils';
import { Box, Flex, Icons, Page, Section, Typography } from 'components';
import SubmenuVertical from 'components/submenuVertical';
import { HeaderPerfil } from 'features/account/components';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Icon = styled(Icons)`
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.white};
`;

const SupportView = () => {
  const navigate = useNavigate();
  const [subAreaIndex, setSubAreaIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Page title="Meu Perfil">
      <HeaderPerfil areaIndex={5} onAreaClick={(value) => navigate(createUrl(value))} />
      <Flex flexDirection="row" bg="white">
        <SubmenuVertical
          areas={['Fale com a gente', 'Perguntas Frequentes']}
          areaIndex={subAreaIndex}
          onAreaClick={(index) => setSubAreaIndex(index)}
        />

        <Flex py={{ m: 30, t: 60, d: 60 }} bg="white" flexGrow={0} marginLeft={isMobile ? '5%' : '15%'}>
          <Section flexDirection={{ m: 'column', d: 'row' }} justifyContent="space-between" flexWrap="nowrap">
            <Flex flex={1} minHeight="480px">
              {subAreaIndex === 0 ? (
                <Flex
                  flexGrow={0}
                  bg="white"
                  borderRadius={5}
                  onClick={() => {}}
                  style={{ cursor: 'pointer' }}
                  borderWidth={2}
                  borderStyle="solid"
                  borderColor="primary_400"
                  height={60}
                  width={isMobile ? 360 : 400}
                  paddingX={1}
                  alignItems="center"
                >
                  <Flex flexGrow={0} mr={3} bg="primary_400" padding={1} borderRadius={5}>
                    <Icon icon="whatsapp" />
                  </Flex>

                  <Flex flexDirection="column">
                    <Typography type={isMobile ? 'type1' : 'type2'} color="gray_600" upper fontWeight="bold">
                      Whatsapp
                    </Typography>
                    <Typography type="type0" color="gray_500">
                      Entre em contato com nossa equipe por Whatsapp
                    </Typography>
                  </Flex>
                </Flex>
              ) : null}
            </Flex>
          </Section>
        </Flex>
      </Flex>
    </Page>
  );
};

export default SupportView;
